import React from 'react';
import TrashCan from '@uber/base-icons/trash-can';
import { styled } from 'baseui';
import { type ButtonProps, Button, KIND, SHAPE, SIZE } from 'baseui/button';
import { ParagraphSmall } from 'baseui/typography';
import type { ReviewAnnotationInstanceT } from '../types';
type Props = {
  instances: ReviewAnnotationInstanceT[];
  currentInstanceIndex: number;
  onInstanceSelect: (index: number) => void;
  onInstanceDelete?: (index: number) => void;
};
const optionButtonProps: ButtonProps = {
  kind: KIND.tertiary,
  shape: SHAPE.square,
  size: SIZE.mini
};
const Container = styled('div', ({
  $theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  flexShrink: 0,
  gap: $theme.sizing.scale500,
  maxHeight: $theme.sizing.scale3200,
  overflow: 'auto',
  padding: `${$theme.sizing.scale300} 0`,
  marginBottom: $theme.sizing.scale800
}));
const InstanceItem = styled<'div', {
  $isSelected: boolean;
}>('div', ({
  $theme,
  $isSelected
}) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  borderWidth: $theme.sizing.scale0,
  borderStyle: 'solid',
  borderColor: $isSelected ? $theme.colors.borderSelected : $theme.colors.borderOpaque,
  borderRadius: $theme.borders.radius200,
  padding: $theme.sizing.scale100,
  paddingLeft: $theme.sizing.scale400,
  cursor: 'pointer'
}));
const OptionsContainer = styled('div', ({
  $theme
}) => ({
  display: 'flex',
  gap: $theme.sizing.scale0
}));
const StyledParagraphSmall = styled<typeof ParagraphSmall, {
  $isSelected: boolean;
}>(ParagraphSmall, ({
  $theme,
  $isSelected
}) => ({
  margin: $theme.sizing.scale100,
  color: $isSelected ? $theme.colors.contentPrimary : $theme.colors.contentTertiary
}));
export const InstanceList = ({
  instances,
  currentInstanceIndex,
  onInstanceSelect,
  onInstanceDelete
}: Props) => {
  return <Container>
      {instances.map(({
      key,
      startIndex,
      endIndex
    }, index) => <InstanceItem key={`${key}-${startIndex}-${endIndex}`} $isSelected={currentInstanceIndex === index} onClick={() => onInstanceSelect(index)}>
          <StyledParagraphSmall $isSelected={currentInstanceIndex === index}>
            {`${key} : ${startIndex} -> ${endIndex}`}
          </StyledParagraphSmall>
          {currentInstanceIndex === index && <OptionsContainer>
              {onInstanceDelete && <Button {...optionButtonProps} onClick={() => onInstanceDelete(index)} data-testid="delete-instance-button">
                  <TrashCan />
                </Button>}
            </OptionsContainer>}
        </InstanceItem>)}
    </Container>;
};